import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom"; // To handle redirects
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faKey,
  faSignOutAlt,
  faUserCircle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  Row,
  Col,
  Nav,
  Form,
  Image,
  Navbar,
  Dropdown,
  Container,
  Modal,
  Button,
  ListGroup,
} from "@themesberg/react-bootstrap";
import Profile3 from "../assets/img/profile_pic.png";
import NOTIFICATIONS_DATA from "../data/notifications";
import axios from "axios";
import "../index.css";
import BASE_URL from "../config";

export default () => {
  // const [notifications, setNotifications] = useState(NOTIFICATIONS_DATA);
  const [notifications, setNotifications] = useState([]);
  const [username, setUsername] = useState("");
  const [user, setUser] = useState(null);
  const [userRole, setUserRole] = useState("");
  const [showProfileModal, setShowProfileModal] = useState(false); // To manage profile modal visibility
  const [showPasswordModal, setShowPasswordModal] = useState(false); // To manage password modal visibility
  const [showSuccessPopup, setShowSuccessPopup] = useState(false); // Success popup visibility
  const [newPassword, setNewPassword] = useState(""); // To store the new password
  const [confirmPassword, setConfirmPassword] = useState(""); // To store the confirm password
  const [errorMessage, setErrorMessage] = useState(""); // To display validation messages
  const history = useHistory(); // Hook for redirecting
  const [todayUpdates, setTodayUpdates] = useState([]); // Store today's updates
  const [newApplications, setNewApplications] = useState([]);
  const [viewAll, setViewAll] = useState(false);
  useEffect(() => {
    if (user) {
      const fetchTodayNotifications = async () => {
        try {
          const response = await axios.post(`${BASE_URL}/api.php`, {
            type: "GetNotificationsToday",
            loggedin_user_id: user.id, // Pass the logged-in user's ID
          });

          if (response.data.status === "success") {
            // console.log("Today's Notifications:", response.data.notifications);
            setNotifications(response.data.notifications); // Set fetched notifications
          } else {
            console.error("Error fetching notifications:", response.data.error);
          }
        } catch (error) {
          console.error("Error fetching today's notifications:", error);
        }
      };

      fetchTodayNotifications();
    }
  }, [user]);
 // Add 'user' as a dependency
  



  const toggleViewAll = () => {
    setViewAll(!viewAll);
  };

  const displayedNotifications = viewAll
    ? notifications
    : notifications.slice(0, 1);

  const areNotificationsRead = notifications.reduce(
    (acc, notif) => acc && notif.read,
    true
  );

  useEffect(() => {
    const loggedInUser = JSON.parse(
      localStorage.getItem("authToken")
    );

    if (loggedInUser) {
      setUsername(loggedInUser.name || "");
      setUser(loggedInUser);

      // Convert database user_type into readable role
      switch (String(loggedInUser.user_type)) {
        case "0":
          setUserRole("Manager");
          break;

        case "1":
          setUserRole("Admin");
          break;

        case "2":
          setUserRole("Applicant");
          break;

        default:
          setUserRole("User");
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
    history.push("/");
  };

  const markNotificationsAsRead = () => {
    setTimeout(() => {
      setNotifications(notifications.map((n) => ({ ...n, read: true })));
    }, 300);
  };

  const handleProfileClick = () => setShowProfileModal(true);
  const closeProfileModal = () => setShowProfileModal(false);

  const handleChangePasswordClick = () => setShowPasswordModal(true);
  const closePasswordModal = () => {
    setShowPasswordModal(false);
    setNewPassword("");
    setConfirmPassword("");
    setErrorMessage("");
  };

  const closeSuccessPopup = () => setShowSuccessPopup(false);

  const handlePasswordUpdate = async () => {
    if (!newPassword || !confirmPassword) {
      setErrorMessage("Both fields are required.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwords do not match.");
      return;
    }

    try {
      const userId = user.id;
      const response = await axios.put(`${BASE_URL}/api.php`, {
        type: "updatePassword",
        id: userId,
        password: newPassword,
      });

      if (response.data.success) {
        setShowSuccessPopup(true);
        closePasswordModal();
        setTimeout(closeSuccessPopup, 3000); // Automatically close after 3 seconds
      } else {
        setErrorMessage(response.data.message || "Failed to update password.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
      setErrorMessage("Failed to update password. Please try again.");
    }
  };
  // Mapping statuses to colors
  const statusStyles = {
    0: { background: "#d4edda", color: "#155724" }, // Application Approved - Green
    1: { background: "#f8d7da", color: "#721c24" }, // Application Declined - Red
    2: { background: "#fff3cd", color: "#856404" }, // Application Suspended - Yellow
    3: { background: "#e2e3e5", color: "#383d41" }, // Incomplete Application - Gray
    4: { background: "#cce5ff", color: "#004085" }, // Waiting For Merchant - Blue
    5: { background: "#d1ecf1", color: "#0c5460" }, // Waiting For Bank - Light Blue
    6: { background: "#fefefe", color: "#818182" }, // Waiting For Agent - Light Gray
    7: { background: "#d4edda", color: "#155724" }, // Application Applied - Green
  };

  const statusMap = {
    0: "Application Approved",
    1: "Application Declined",
    2: "Application Suspended",
    3: "Incomplete Application",
    4: "Waiting For Merchant",
    5: "Waiting For Bank",
    6: "Waiting For Agent",
    7: "Application Applied",
  };

 

  const Notification = (props) => {
    const {  title, message, created_at } = props;

  
    // Handle the notification click
    const handleNotificationClick = () => {
      // If notifications are associated with an application, you can pass an ID in the URL
      // const query = new URLSearchParams({ applicationId }).toString();
      // window.location.href = `/application#/application?${query}`; // Redirect with notification ID
      // window.location.href = `${window.location.origin}/#/application?${query}`;


      const query = new URLSearchParams({ applicationId }).toString();
      // console.log(query);
      history.push(`/application?${query}`);
    };

    
    const extractApplicationId = (title) => {
      const match = title.match(/Application id (\d+)/); // Match the "Application id <number>"
      return match ? match[1] : null; // Return the matched ID or null if no match
    };
  
    const applicationId = extractApplicationId(title);


    return (
      <ListGroup.Item
        action
        className="border-bottom border-light"
        onClick={handleNotificationClick} // Trigger redirect on click
      >
        <Row className="align-items-center">
          <Col className="ps-0 ms--2">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-0 h6 text-small">{title}</h4>
              </div>
              <div className="text-end">
                <small className="text-muted">
                  {new Date(created_at).toLocaleDateString()} {/* Display date */}
                </small>
              </div>
            </div>
            <p className="mt-1 mb-0 font-small">{message}</p>
          </Col>
        </Row>
      </ListGroup.Item>
    );
  };
  

  return (
    <>
      <Navbar expanded className="top-navbar px-3">
  <Container fluid className="px-0 ">
    <div className="d-flex justify-content-between w-100">
      <div className="d-flex align-items-center">
        {/* Optional page title / breadcrumb area */}
      </div>

      <div className="d-flex align-items-center ms-auto">
        <Nav className="align-items-center">

          {/* Notification */}
          <Dropdown as={Nav.Item} onToggle={markNotificationsAsRead}>
            <Dropdown.Toggle
              as={Nav.Link}
              className="navbar-notification-toggle me-lg-3"
            >
              <span className="navbar-icon-wrapper">
                <FontAwesomeIcon
                  icon={faBell}
                  className="bell-shake"
                />

                {!areNotificationsRead && (
                  <span className="unread-notifications" />
                )}
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="py-0 mt-2 dashboard-dropdown notifications-dropdown dropdown-menu-lg dropdown-menu-center">
              <ListGroup className="list-group-flush">

                <Link
                  to="/dashboard/overview"
                  className="notification-header"
                >
                  <FontAwesomeIcon icon={faBell} className="me-2" />
                  Notifications
                </Link>

                {displayedNotifications.map((n, index) => (
                  <Notification
                    key={index}
                    {...n}
                  />
                ))}

                <Dropdown.Item
                  className="notification-view-all"
                  onClick={toggleViewAll}
                >
                  {viewAll ? "Show Latest" : "View All"}
                </Dropdown.Item>

              </ListGroup>
            </Dropdown.Menu>
          </Dropdown>


          {/* Profile */}
          <Dropdown as={Nav.Item}>
            <Dropdown.Toggle
              as={Nav.Link}
              className="profile-toggle px-0"
            >
              <div className="profile-wrapper d-flex align-items-center">

                <div className="profile-avatar-wrapper">
                  <Image
                    src={Profile3}
                    className="profile-avatar"
                  />

                  <span className="profile-online-dot" />
                </div>

                <div className="profile-info ms-2 d-none d-lg-block">
                  <span className="profile-name">
                    {username}
                  </span>

                  <small className="profile-role">
                    {userRole}
                  </small>
                </div>

              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="mt-2 user-dropdown dropdown-menu-right">

              <Dropdown.Item
                className="fw-bold"
                onClick={handleProfileClick}
              >
                <FontAwesomeIcon
                  icon={faUserCircle}
                  className="me-2"
                />
                My Profile
              </Dropdown.Item>

              <Dropdown.Item
                className="fw-bold"
                onClick={handleChangePasswordClick}
              >
                <FontAwesomeIcon
                  icon={faKey}
                  className="me-2"
                />
                Change Password
              </Dropdown.Item>

              <Dropdown.Divider />

              <Dropdown.Item
                className="fw-bold"
                onClick={handleLogout}
              >
                <FontAwesomeIcon
                  icon={faSignOutAlt}
                  className="text-danger me-2"
                />
                Logout
              </Dropdown.Item>

            </Dropdown.Menu>
          </Dropdown>

        </Nav>
      </div>
    </div>
  </Container>
</Navbar>

      {/* Profile Modal */}
      <Modal show={showProfileModal} onHide={closeProfileModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>My Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center d-flex flex-column align-items-center ">
          <Image
            src={Profile3}
            className="mb-3 user-avatar lg-avatar rounded-circle"
          />
          <h5 className="fw-bold">{username}</h5>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeProfileModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Password Modal */}
      <Modal show={showPasswordModal} onHide={closePasswordModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter new password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
            {errorMessage && (
              <p className="text-center text-danger">{errorMessage}</p>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closePasswordModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handlePasswordUpdate}>
            Update Password
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Success Popup */}
      {showSuccessPopup && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "rgba(255, 255, 255, 0.9)",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            padding: "20px 30px",
            zIndex: 1050,
            textAlign: "center",
          }}
        >
          <FontAwesomeIcon
            icon={faCheckCircle}
            className="text-success"
            size="3x"
          />
          <h5 className="mt-3 fw-bold">Password Updated Successfully!</h5>
        </div>
      )}
    </>
  );
};
